var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecaptchaHeader = function SvgRecaptchaHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 12,
    y: 12,
    fill: "url(#recaptcha_header_svg__a)",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34 12h3v72h-3zM59 12h3v72h-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84 34v3H12v-3zM84 59v3H12v-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M59 37v22H37V37zM34 12v22H12V24c0-6.627 5.373-12 12-12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C9FF",
    d: "M59 12v22H37V12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006AFF",
    d: "M84 62v10c0 6.627-5.373 12-12 12H62V62z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recaptcha_header_svg__a",
    x1: 75.161,
    x2: 38.699,
    y1: 84.59,
    y2: 3.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#006AFF"
  })))));
};
export { SvgRecaptchaHeader as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIxMiIgeT0iMTIiIHdpZHRoPSI3MiIgaGVpZ2h0PSI3MiIgcng9IjEyIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjAwN18zNjM1OCkiIC8+CiAgPHJlY3QgeD0iMzQiIHk9IjEyIiB3aWR0aD0iMyIgaGVpZ2h0PSI3MiIgZmlsbD0id2hpdGUiIC8+CiAgPHJlY3QgeD0iNTkiIHk9IjEyIiB3aWR0aD0iMyIgaGVpZ2h0PSI3MiIgZmlsbD0id2hpdGUiIC8+CiAgPHJlY3QgeD0iODQiIHk9IjM0IiB3aWR0aD0iMyIgaGVpZ2h0PSI3MiIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgODQgMzQpIiBmaWxsPSJ3aGl0ZSIgLz4KICA8cmVjdCB4PSI4NCIgeT0iNTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjcyIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA4NCA1OSkiIGZpbGw9IndoaXRlIiAvPgogIDxyZWN0IHg9IjU5IiB5PSIzNyIgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA1OSAzNykiIGZpbGw9IiMxMjEyMTIiIC8+CiAgPHBhdGggZD0iTTM0IDEyTDM0IDM0TDEyIDM0TDEyIDI0QzEyIDE3LjM3MjYgMTcuMzcyNiAxMiAyNCAxMkwzNCAxMloiIGZpbGw9IiMxMjEyMTIiIC8+CiAgPHJlY3QgeD0iNTkiIHk9IjEyIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHRyYW5zZm9ybT0icm90YXRlKDkwIDU5IDEyKSIgZmlsbD0iI0EwQzlGRiIgLz4KICA8cGF0aCBkPSJNODQgNjJMODQgNzJDODQgNzguNjI3NCA3OC42Mjc0IDg0IDcyIDg0TDYyIDg0TDYyIDYyTDg0IDYyWiIgZmlsbD0iIzAwNkFGRiIgLz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl82MDA3XzM2MzU4IiB4MT0iNzUuMTYwNyIgeTE9Ijg0LjU5IiB4Mj0iMzguNjk4NSIgeTI9IjMuMzkwNDMiCiAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NBRTJGRiIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjg0IiBzdG9wLWNvbG9yPSIjMDA2QUZGIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==";